<template>
  <div class="commerce-order-driver" :class="$store.state.theme">
    <div class="modal commerce-order-driver-modal" v-if="t">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />
      <div class="modal-card" :key="z">
        <section class="modal-card-body has-text-left no-scrollbar">
          <span class="has-text-link is-pulled-right" style="font-size: 0.8em; margin-top: 3px"
            @click="callPhoneNumber(t.business.data.phone_number)">
            <span class="link">{{ $t("call-shop") }}</span>
            <i class="fa fa-phone" style="margin-left: 6px" />
          </span>
          <h1 class="header">
            {{ fulfilmentType(t) }}
            {{ $t("commerce.order-details") }}
          </h1>

          <div v-if="deliveryNotes" class="delivery-notes has-text-grey" @click="copy(deliveryNotes)">
            <i class="fa fa-motorcycle" />
            {{ $t("driver.driver") }}:
            <span class="has-text-link has-text-weight-medium">
              {{ deliveryNotes }}
            </span>
            <i class="far fa-copy fa-sm has-text-black" />
          </div>

          <div class="transaction">
            <div class="order-no">{{ ref }}</div>
            <div class="columns is-mobile is-vcentered">
              <div class="column is-narrow has-text-centered">
                <img :src="businessProfilePic" />
              </div>
              <div class="column has-text-left" style="padding-left: 0">
                <p class="business-name">
                  <i class="fa fa-store-alt fa-sm has-text-grey pad" />
                  <span>{{ t.business.name }}</span>
                </p>
                <p>
                  <i class="far fa-clock pad" />
                  <span>{{ $t("ecommerce.ordered") }}
                    {{ minutesAgo(t.created_at) }}</span>
                </p>
                <p>
                  <i class="fa fa-coins pad" />
                  <!-- <span>{{ currency }}{{ orderValue }}</span> -->
                  <span class="has-text-link is-uppercase payment">{{
                    translatePayment(t.data.order.payment_method)
                  }}</span>
                  <span v-if="paymentReceipt">
                    <i class="fa fa-check-circle has-text-success" /> PAID
                  </span>
                </p>
              </div>
            </div>
          </div>

          <!-- <p class="has-text-danger">Double check items before leaving the shop</p> -->
          <table class="table is-fullwidth" style="margin-bottom: 0">
            <thead style="background-color: white">
              <tr class="no-bottom-border">
                <th style="padding-right: 0; font-size: 1.2em">
                  <span class="qty-total">{{ basketItemCount }}</span>{{ $t("menu.items-total") }}
                  <span class="buttons is-uppercase">
                    <span v-for="(l, i) in languages" :key="i" class="button is-small is-rounded"
                      :class="{ 'is-light': lang !== l }" @click="lang = l">{{ l }}</span>
                  </span>
                </th>
                <th class="has-text-grey has-text-right" @click="toggleMore">
                  <span class="link">
                    <i class="fa fa-camera-retro" />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(o, i) in basketItems" :key="i" :class="{
                'special-item-positive':
                  isSpecialItem(o) && discountedTotalPrice(o.item) >= 0,
                'special-item-negative':
                  isSpecialItem(o) && discountedTotalPrice(o.item) < 0,
              }">
                <td class="wide" style="padding-right: 0">
                  <span class="qty-left">{{ actualQuantity(o) }}</span>
                  <span v-if="isSpecialItem(o)">*</span>{{ itemName(o.item)
                  }}<span v-if="isSpecialItem(o)">*</span>
                  <!-- <i v-if="o.item.discount" class="fa fa-tag has-text-danger" style="opacity: 0.7; font-size: 0.7em; margin-left: 2px" /> -->
                  <p v-if="hasOptionsOrComment(o)" class="options">
                    <span v-html="prettyOptions(o.item.options)" />
                    <span v-if="o.item.comment" @click="copy(o.item.comment)">
                      <br v-if="o.item.options && o.item.options.length" />
                      <i class="far fa-comment-alt has-text-grey" />
                      {{ o.item.comment }}
                      <i class="far fa-copy fa-sm has-text-black" />
                    </span>
                  </p>

                  <p v-if="showDescriptions" class="description">
                    {{ itemDescription(o.item) }}
                  </p>
                  <p v-show="showPics">
                    <img class="item-img" v-webp="o.item.pic || placeholderPic"
                      :class="{ 'contain-img': o.item.contain_image }" />
                  </p>
                </td>
                <td v-if="showPrices">
                  {{ currency }}{{ discountedTotalPrice(o.item) }}
                </td>
                <td v-else style="margin: 0; padding: 0" @click="toggleMore">
                  <img class="item-img small" v-webp="o.item.pic || placeholderPic" />
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="cashback" class="notes transaction" style="background-color: lightyellow" @click="showCashbackInfo">
            <i class="has-text-link">{{ $t("promos.cashback-promo") }}</i>
            <span class="is-pulled-right label">{{ youGetXCashback }}
              <i class="fa fa-info-circle" style="margin-left: 4px; color: #bbb" />
            </span>
          </div>

          <div v-if="orderNotes" class="notes has-text-grey" @click="copy(orderNotes)">
            <i class="far fa-comment-alt" />
            {{ $t("ecommerce.notes") }}:&nbsp;
            <span class="has-text-link">{{ orderNotes }}</span>
            <i class="far fa-copy fa-sm has-text-black" />
          </div>

          <div style="margin-top: 10px; text-align: right">
            <span v-if="paymentReceipt" class="is-pulled-left" style="font-weight: 500; color: grey">{{
              $t("ecommerce.payment-receipt") }}</span>
            <span class="tag is-white has-text-grey" @click="copyOrderID">{{ $t("ecommerce.order-id") }}&nbsp;
              <span class="has-text-weight-medium">
                {{ orderID }}
              </span>
            </span>
          </div>

          <img v-if="paymentReceipt" :src="paymentReceipt" style="width: 100%; height: auto" />
        </section>
      </div>
    </div>
  </div>
</template>


<script>
import EventBus from "../eventBus";

export default {
  name: "CommerceOrderDriverModal",
  components: {},
  data() {
    return {
      transaction: null,
      z: 0,
      lang: this.$store.state.language,
      showDescriptions: false,
      showPics: false,
      placeholderPic: this.$store.state.menuItemPlaceholderPic,
    };
  },
  computed: {
    showPrices() {
      if (this.isSuperUser()) return true;
      return this.t.data.delivery.require_receipt;
    },
    youGetXCashback() {
      var amount = `${this.currency}${this.cashback}`;
      return this.$t("promos.you-get-x", { x: amount });
    },
    t() {
      return this.transaction;
    },
    ref() {
      if (this.t.data.ref_prefix) {
        return this.t.data.ref_prefix + this.t.data.ref;
      }
      return "#" + this.t.data.ref;
    },
    paymentReceipt() {
      return this.t.data.payment_receipt_pic;
    },
    orderID() {
      return this.t.id.substr(this.t.id.length - 5);
    },
    businessProfilePic() {
      var fallback = "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // default profile photo
      return this.t.business.profile_pic_url || fallback;
    },
    basketItems() {
      return this.t.data.order.basket.items.filter(o => this.actualQuantity(o));
    },
    basketItemCount() {
      var sum = 0;
      this.basketItems.forEach((o) => {
        sum = sum + this.actualQuantity(o);
      });
      return sum;
    },
    languages() {
      return this.t.data.order.basket.languages || ["en", "th"];
      // check languages object on first item to get languages set to true << OLD WAY FIX IT
      // if (!this.basketItems.length) return [];
      // var obj = this.basketItems[0].item.languages;
      // if (!obj) return [];
      // return Object.keys(obj).filter((k) => {
      //   return obj[k];
      // });
    },
    cashback() {
      return this.t.data.order.cashback;
    },
    orderNotes() {
      return this.t.data.order.basket.notes;
    },
    deliveryNotes() {
      if (!this.t.data.address) return null;
      return this.t.data.address.notes;
    },
    // itemsCount() {
    //   var cnt = 0;
    //   this.basketItems.forEach((o) => (cnt += o.quantity));
    //   return cnt;
    // },
    // deprecate this for customer
    orderValueCustomer() {
      var orderValue = this.t.data.order.order_value + this.vat;
      if (this.t.data.type !== "delivery") return orderValue;
      if (this.t.data.delivery.is_free_delivery) {
        return orderValue;
      } else {
        var deliveryFee = this.subsidisedDeliveryFee; //this.t.data.fare.price;
        return orderValue + deliveryFee;
      }
    },
    orderValueDriver() {
      var orderValue = this.t.data.order.order_value + this.vat; // add fees discounts
      if (this.t.data.type !== "delivery") return orderValue;
      if (this.t.data.delivery.is_free_delivery) {
        var deliveryFee = this.t.data.fare.price;
        return orderValue - deliveryFee;
      } else {
        return orderValue;
      }
    },
    vat() {
      return this.t.data.order.vat || 0;
    },
    subsidisedDeliveryFee() {
      return this.t.data.fare.price - this.t.data.order.delivery_subsidy;
    },
    deliveryFee() {
      if (this.t.data.type !== "delivery") return 0;
      var deliveryFee = this.subsidisedDeliveryFee; //this.t.data.fare.price;
      if (this.isCustomer) {
        if (this.t.data.delivery.is_free_delivery) return 0;
        else return deliveryFee;
      } else {
        if (this.t.data.delivery.is_free_delivery) return deliveryFee;
        else return 0;
      }
    },
    showDeliveryFee() {
      if (this.t.data.type !== "delivery") return false;
      if (this.isCustomer) return true;
      // else driver
      if (this.t.data.delivery.is_free_delivery) return true;
      return false;
    },
    currency() {
      var country = "th"; // default country
      if (this.t.data.business) country = this.t.data.business.country;
      return this.currencySymbol(country); // should store in order
    },
  },
  mounted() {
    EventBus.$on("COMMERCE_ORDER_DRIVER_MODAL", (t) => this.init(t));
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    copy(txt) {
      this.$copyText(txt);
      this.infoToast("Copied to clipboard!<br>" + txt);
    },
    copyOrderID() {
      this.infoToast("Copied order ID<br>" + this.t.id);
      this.$copyText(this.t.id);
    },
    hasOptionsOrComment(o) {
      var options = o.item.options || [];
      return options.length || o.item.comment;
    },
    toggleMore() {
      this.showDescriptions = !this.showDescriptions;
      this.showPics = !this.showPics;
    },
    showCashbackInfo() {
      this.$swal({
        html: `<div style='text-align: left'>
        <p style="font-size:1.2em">🎉 Happy Songkran!</p>
        <p style="margin-top:10px; font-size:0.9em"><i>You get cashback!</i></p>
        <p style="margin-top:10px; font-size:0.85em; font-weight:500; opacity:0.7">
        <i>Your friendly TUK driver will give you the cashback on arrival with your delivery.</i>
        </p>
        </div>`,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: this.$t("okay"),
        confirmButtonColor: this.bulmaColor("success"),
      });
    },
    prettyOptions(options) {
      var style = "style='color: grey; font-size: 0.85em; font-weight: 500;'";
      return options
        .map((o) => {
          var menu = o.menu.name;
          if (o.menu[this.lang]) menu = o.menu[this.lang];
          var option = o.option.name;
          var quantity = o.option.quantity || 1;
          if (o.option[this.lang]) option = o.option[this.lang].name;
          return `<span ${style}>&nbsp;•&nbsp;${menu}</span> ${quantity} x ${option}`;
        })
        .join("<br>");
    },
    isSpecialItem(o) {
      if (o.item.id && o.item.id.startsWith("~")) return true;
      return false;
    },
    deliveryState(t) {
      if (!t.delivery) return "None";
      var state = t.delivery.state;
      return this.translateState(state);
    },
    fulfilmentType(t) {
      return this.translateFulfilmentType(t.data.type);
    },
    init(t) {
      this.transaction = t;
      //  this.z += 1
    },
    itemName(o) {
      if (o[this.lang]) {
        return o[this.lang].name;
      }
      return o.name;
    },
    itemDescription(o) {
      if (o[this.lang]) {
        return o[this.lang].description || "~";
      }
      return "~"; //o.name; // or "~"
    },
  },
};
</script>

<style scoped>
.notes {
  /* padding-top: 8px;
  background-color: white; */
  /* background-color: rgb(245, 245, 245); */
  border-radius: 2px;
  margin-top: 8px;
  padding: 5px 10px;
  border: 1px solid lightgrey;
}

.delivery-notes {
  background-color: rgba(255, 255, 0, 0.6);
  margin-bottom: 8px;
  border: 1px solid black;
  padding: 3px 6px;
  border-radius: 3px;
}

.transaction {
  position: relative;
  border-radius: 2px;
  border: 1px solid lightgrey;
  /* box-shadow: 0px 1px 1px lightgrey; */
  width: 100%;
}

.driver {
  width: 100%;
  margin-top: 8px;
  background-color: lightyellow;
}

.hack {
  margin-top: 8px;
  background-color: rgba(144, 238, 144, 0.619);
  text-align: center;
  padding: 6px;
  font-style: italic;
  width: 100%;
}

.columns {
  padding: 0 0;
  margin: 0 0;
}

.columns:last-child {
  margin-bottom: 0;
}

.tag {
  padding: 0 6px;
}

.pad {
  margin-right: 8px;
  color: grey;
}

.modal-card {
  width: 95vw;
}

.modal-card-body {
  max-height: calc(100vh - 110px);
  padding: 10px;
  z-index: 999999999;
  overflow-x: hidden;
}

p {
  margin-bottom: 0px !important;
}

.table {
  background-color: rgb(245, 245, 245);
  /* border-radius: 3px; */
  margin-top: 8px;
  /* box-shadow: 0px 0px 2px 1px lightgrey; */
  box-shadow: 0 0 1px #999;
}

.contain-img {
  object-fit: contain !important;
}

img {
  height: 80px;
  width: auto;
  border-radius: 2px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  margin-bottom: -7px;
}

.is-narrow {
  padding: 5px;
}

.item-img {
  border-radius: 2px;
  object-fit: cover;
  height: 140px;
  width: 140px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.item-img.small {
  height: 37px;
  width: 37px;
}

.description {
  background-color: lightyellow;
  padding: 2px;
  border-radius: 4px;
}

.payment {
  background-color: snow;
  padding: 0 4px;
  border-radius: 4px;
  margin-left: -2px;
  font-weight: 500;
}

.options {
  font-size: 0.9em;
  /* background-color: rgba(224, 255, 255, 0.7); */
  background-color: white;
  padding: 0 3px;
  border-radius: 3px;
  margin-top: 3px;
}

.special-item-positive {
  color: green;
}

.special-item-negative {
  color: red;
}

.total-row th {
  padding: 4px 10px;
}

.qty-left {
  line-height: 1.2em;
  display: inline-block;
  padding: 0 7px;
  padding-top: 3px;
  border-radius: 3px;
  border: 1px solid #209cee;
  font-weight: 500;
  margin-right: 4px;
}

.qty-total {
  line-height: 1.2em;
  display: inline-block;
  padding: 0 7px;
  padding-top: 3px;
  border-radius: 3px;
  border: 1px solid black;
  font-weight: 550;
  margin-right: 4px;
}

.order-no {
  position: absolute;
  margin: -1px;
  font-size: 1.2em;
  padding: 0 3px;
  line-height: 1.2em;
  font-weight: 550;
  border-radius: 2px;
  border: 1px dotted black;
  background-color: rgba(224, 255, 255, 0.9);
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
  box-shadow: 0 0 2px grey;
}

.header {
  color: grey;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 1.15em;
}

.no-bottom-border th {
  border-bottom: none;
}

.wide {
  width: 100%;
}

td,
th {
  padding: 6px 8px;
}

.buttons {
  display: inline-block;
  margin-left: 4px;
  font-weight: 450;
}

.buttons .button {
  padding: 0 4px;
  margin: 0 3px;
  /* margin-top: -2px; */
}

.business-name {
  width: calc(100% - 20px);
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
